import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf"
import Register from "../Pages/Register";

const SalesSummaryPage = () => {
  const { state } = useLocation();

  const ticketsData = state?.ticketsData || [];
  const usersData = state?.usersData || [];
  const showsData = state?.showsData || [];
  const user = state?.user;
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [page, setPage] = useState(1);
  const [showRegister, setShowRegister] = useState(false);
  const [cashierFilter, setCashierFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [search, setSearch] = useState("");

  const perPage = 10;

  let filteredTickets = [...ticketsData];


  if (!user?.isAdmin) {
    filteredTickets = filteredTickets.filter(
      (t) => t.userId === user.id
    );
  }

  if (cashierFilter) {
    filteredTickets = filteredTickets.filter(
      (t) => String(t.userId) === String(cashierFilter)
    );
  }

  if (typeFilter) {
    filteredTickets = filteredTickets.filter((t) => {
      const u = usersData.find((x) => x.id === t.userId);
      if (!u) return false;

      if (typeFilter === "usuarios") {
        return !u.cashier && Number(t.price) > 0;
      }

      if (typeFilter === "cajeros") {
        return u.cashier && Number(t.price) > 0;
      }

      if (typeFilter === "regalados") {
        return Number(t.price) === 0;
      }

      return true;
    });
  }

  if (search.trim()) {
    const s = search.toLowerCase();

    filteredTickets = filteredTickets.filter((t) => {
      const u = usersData.find((x) => x.id === t.userId);
      const show = showsData.find((x) => x.id === t.showId);

      return (
        String(t.id).includes(s) ||
        u?.name?.toLowerCase().includes(s) ||
        u?.email?.toLowerCase().includes(s) ||
        show?.name?.toLowerCase().includes(s)
      );
    });
  }

  const totalPages = Math.ceil(filteredTickets.length / perPage);
  const start = (page - 1) * perPage;
  const paginated = filteredTickets.slice(start, start + perPage);
  let totalSinRecargo = 0;
  let totalConRecargo = 0;
  let totalRecargo = 0;

  filteredTickets.forEach((t) => {

    const gifted = Number(t.price) === 0;

    const base = gifted
      ? 0
      : Number(t.price ?? 0);

    const final = gifted
      ? 0
      : t.cash
        ? base
        : Number(t.chargePrice ?? base);

    totalSinRecargo += base;
    totalConRecargo += final;
    totalRecargo += final - base;
  });

  const formatDate = (createdAt) => {
    const d = new Date(createdAt);
    return {
      date: d.toLocaleDateString("es-AR"),
      time: d.toLocaleTimeString("es-AR", {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
  };


  const downloadTicketPDF = (ticket) => {
    const doc = new jsPDF();

    const finalPrice =
      Number(ticket.price) === 0
        ? ticket.price
        : ticket.chargePrice ?? ticket.price;

    const showName =
      showsData.find(show => show.id === ticket.showId)?.name ||
      "Show desconocido";

    const dateTimeParts = ticket.date?.split(" || ") || [];
    const eventDate = dateTimeParts[0] || "";
    const eventTime = dateTimeParts[1]?.split(" - ")[1] || "";

    // HEADER
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);

    doc.setLineWidth(0.5);
    doc.line(20, 25, 190, 25);

    // CONTENIDO
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    doc.text(`Ticket N°${ticket.id}`, 20, 30);
    doc.text(`Usuario: ${ticket.name || "-"}`, 20, 40);
    doc.text(`Evento: ${showName}`, 20, 50);
    doc.text(`Fecha: ${eventDate}`, 20, 60);
    doc.text(`Hora: ${eventTime}`, 20, 70);
    doc.text(`Zona: ${ticket.division || "-"}`, 20, 80);

    if (ticket.row && ticket.seat) {
      doc.text(`Fila: ${ticket.row}`, 20, 90);
      doc.text(`Asiento: ${ticket.seat}`, 20, 100);
    } else {
      doc.text(`Fila: General`, 20, 90);
      doc.text(`Asiento: General`, 20, 100);
    }

    if (ticket.price !== undefined && ticket.price !== null) {
      doc.text(
        `Precio: ${Number(finalPrice ?? 0).toFixed(2)}`,
        20,
        110
      );
    }

    // QR
    if (ticket.qrCode) {
      const qrSize = 60;
      const pageWidth = doc.internal.pageSize.getWidth();
      const x = (pageWidth - qrSize) / 2;

      doc.addImage(
        ticket.qrCode,
        "PNG",
        x,
        130,
        qrSize,
        qrSize
      );
    }

    // FOOTER
    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");

    doc.text(
      "Gracias por su compra. Conserve esta entrada para el acceso al evento.",
      105,
      200,
      {
        align: "center",
        maxWidth: 170,
      }
    );

    doc.save(`Ticket_${ticket.id}.pdf`);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();

    let y = 15;

    // =========================
    // TÍTULO
    // =========================
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Resumen de Ventas", 14, y);

    y += 10;

    // =========================
    // HEADERS
    // =========================
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    doc.text("ID", 10, y);
    doc.text("Show", 25, y);
    doc.text("Usuario", 70, y);
    doc.text("Tipo", 110, y);
    doc.text("Fecha", 135, y);
    doc.text("Hora", 160, y);
    doc.text("Total", 180, y);

    y += 6;

    doc.setFont(undefined, "normal");

    // =========================
    // DATA
    // =========================
    filteredTickets.forEach((t) => {
      const u = usersData.find((x) => x.id === t.userId);
      const s = showsData.find((x) => x.id === t.showId);

      const date = new Date(t.createdAt);

      const fDate = date.toLocaleDateString("es-AR");
      const fTime = date.toLocaleTimeString("es-AR", {
        hour: "2-digit",
        minute: "2-digit",
      });

      const basePrice = Number(t.price ?? 0);

      const finalPrice = t.cash
        ? basePrice
        : Number(t.chargePrice ?? basePrice);

      const totalText =
        basePrice === 0
          ? "Regalado"
          : `$${finalPrice.toLocaleString()}`;

      const row = {
        id: `#${t.id}`,
        show: (s?.name || "-").slice(0, 14),
        user: (u?.name || "-").slice(0, 14),
        type: u?.cashier ? "Cajero" : "Usuario",
        date: fDate,
        time: fTime,
        total: totalText,
      };

      doc.text(row.id, 10, y);
      doc.text(row.show, 25, y);
      doc.text(row.user, 70, y);
      doc.text(row.type, 110, y);
      doc.text(row.date, 135, y);
      doc.text(row.time, 160, y);
      doc.text(row.total, 180, y);

      y += 6;

      if (y > 270) {
        doc.addPage();
        y = 15;
      }
    });

    // =========================
    // RESUMEN FINAL
    // =========================

    y += 10;

    if (y > 250) {
      doc.addPage();
      y = 20;
    }

    const totalTickets = filteredTickets.length;

    let totalSinRecargo = 0;
    let totalConRecargo = 0;
    let totalRecargo = 0;

    filteredTickets.forEach((t) => {
      const base = Number(t.price ?? 0);
      const final =
        Number(t.price) === 0
          ? 0
          : Number(t.chargePrice ?? t.price ?? 0);

      totalSinRecargo += base;
      totalConRecargo += final;
      totalRecargo += final - base;
    });


    // 🔥 LÍNEA SUPERIOR
    doc.setDrawColor(180);
    doc.line(10, y, 200, y);

    y += 8; // 👈 IMPORTANTE: bajar cursor DESPUÉS de la línea

    doc.setFontSize(11);
    doc.setFont(undefined, "bold");


    doc.text(`Tickets totales: ${totalTickets}`, 10, y);
    y += 6;

    doc.text(`Neto: $${totalSinRecargo.toLocaleString()}`, 10, y);
    y += 6;

    doc.text(`Bruto: $${totalConRecargo.toLocaleString()}`, 10, y);
    y += 6;

    doc.text(`Ganancia por recargo: $${totalRecargo.toLocaleString()}`, 10, y);
    y += 8;

    doc.setDrawColor(180);
    doc.line(10, y, 200, y);

    // =========================
    // DESCARGA
    // =========================
    doc.save("resumen-ventas.pdf");
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white p-6 mt-[230px]">

      <div className="max-w-6xl mx-auto">

        {/* HEADER */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
          <h1 className="text-3xl font-bold text-sky-400">
            Resumen de Ventas
          </h1>

          <button
            onClick={downloadPDF}
            className="bg-sky-600 hover:bg-sky-700 px-4 py-2 rounded-lg font-semibold"
          >
            Descargar PDF
          </button>
        </div>

        {/* FILTROS */}
        <div className="grid md:grid-cols-3 gap-4 mb-6">

          {user?.isAdmin && (
            <select
              className="bg-white/10 p-2 rounded"
              value={cashierFilter}
              onChange={(e) => {
                setCashierFilter(e.target.value);
                setPage(1);
              }}
            >
              <option value="">Todos los cajeros</option>
              {usersData.filter((u) => u.cashier).map((c) => (
                <option className="text-black" key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          )}

          {user?.isAdmin && (
            <select
              className="bg-white/10 p-2 rounded"
              value={typeFilter}
              onChange={(e) => {
                setTypeFilter(e.target.value);
                setPage(1);
              }}
            >
              <option className="text-black" value="">Todos</option>
              <option className="text-black" value="usuarios">Usuarios</option>
              <option className="text-black" value="cajeros">Cajeros</option>
              <option className="text-black" value="regalados">Regalados</option>
            </select>
          )}

          <input
            className="bg-white/10 p-2 rounded"
            placeholder="Buscar..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />

        </div>

        {/* CARDS */}
        <div className="grid grid-cols-4 gap-4 mb-8 text-center">

          <div className="bg-white/10 p-3 rounded">
            Tickets<br />{filteredTickets.length}
          </div>

          <div className="bg-white/10 p-3 rounded">
            Neto<br />${totalSinRecargo.toLocaleString()}
          </div>

          <div className="bg-white/10 p-3 rounded">
            Bruto<br />${totalConRecargo.toLocaleString()}
          </div>

          <div className="bg-white/10 p-3 rounded text-green-400">
            Ganancia por recargo<br />${totalRecargo.toLocaleString()}
          </div>

        </div>

        {/* TABLE */}
        <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden">

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-white/10 text-sky-300">
                <tr>
                  <th className="p-3 text-left">ID</th>
                  <th className="p-3 text-left">Show</th>
                  <th className="p-3 text-left">Usuario</th>
                  <th className="p-3 text-left">Tipo</th>
                  <th className="p-3 text-left">Fecha</th>
                  <th className="p-3 text-left">Hora</th>
                  <th className="p-3 text-left">Total</th>
                </tr>
              </thead>

              <tbody>
                {paginated.map((t) => {
                  const u = usersData.find((x) => x.id === t.userId);
                  const s = showsData.find((x) => x.id === t.showId);
                  const f = formatDate(t.createdAt);

                  return (
                    <tr
                      key={t.id}
                      onClick={() => setSelectedTicket(t)}
                      className="border-t border-white/10 hover:bg-white/10 cursor-pointer"
                    >
                      <td className="p-3">#{t.id}</td>
                      <td className="p-3">{s?.name}</td>
                      <td className="p-3">{u?.name}</td>
                      <td className="p-3">{u?.cashier ? "Cajero" : "Usuario"}</td>
                      <td className="p-3">{f.date}</td>
                      <td className="p-3">{f.time}</td>
                      <td className="p-3 font-semibold">
                        {Number(t.price) === 0
                          ? (
                            <span className="text-yellow-400 font-bold">
                              Regalado
                            </span>
                          )
                          : (
                            `$${(
                              t.cash
                                ? Number(t.price ?? 0)
                                : Number(t.chargePrice ?? t.price ?? 0)
                            ).toLocaleString()}`
                          )
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {selectedTicket && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            {/* Fondo */}
            <div
              className="absolute inset-0 bg-black/60"
              onClick={() => setSelectedTicket(null)}
            />

            {/* Modal */}
            <div
              className="relative bg-[#0C2342] text-white rounded-lg p-6 shadow-md flex flex-col gap-1 max-w-sm w-[90%] z-50"
              onClick={(e) => e.stopPropagation()}
            >

              {/* Cerrar */}
              <div className="flex justify-end">
                <button
                  onClick={() => setSelectedTicket(null)}
                  className="text-xl hover:text-red-400"
                >
                  ✕
                </button>
              </div>

              {(() => {
                const showName =
                  showsData.find(
                    show => show.id === selectedTicket.showId
                  )?.name || "Show desconocido";

                const dateTimeParts =
                  selectedTicket.date?.split(" || ") || [];

                const eventDateStr = dateTimeParts[0] || "";
                const eventTimeStr =
                  dateTimeParts[1]?.split(" - ")[1] || "";

                const eventDateTime =
                  new Date(`${eventDateStr}T${eventTimeStr}:00`);

                const isPastEvent =
                  eventDateTime < new Date();

                const finalPrice =
                  Number(selectedTicket.price) === 0
                    ? selectedTicket.price
                    : selectedTicket.chargePrice ?? selectedTicket.price ?? 0;

                return (
                  <>
                    <p>
                      <strong>Ticket N°</strong>{" "}
                      {selectedTicket.id}
                    </p>

                    <p>
                      <strong>Usuario:</strong>{" "}
                      {selectedTicket.name || "-"}
                    </p>

                    <p>
                      <strong>Evento:</strong>{" "}
                      {showName}
                    </p>

                    <p>
                      <strong>Zona:</strong>{" "}
                      {selectedTicket.division || "-"}
                    </p>

                    <p>
                      <strong>Fecha y Hora:</strong>{" "}
                      {selectedTicket.date || "-"}
                    </p>

                    {selectedTicket.row && selectedTicket.seat ? (
                      <>
                        <p>
                          <strong>Fila:</strong>{" "}
                          {selectedTicket.row}
                        </p>

                        <p>
                          <strong>Asiento:</strong>{" "}
                          {selectedTicket.seat}
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          <strong>Fila:</strong> No corresponde
                        </p>

                        <p>
                          <strong>Asiento:</strong> No corresponde
                        </p>
                      </>
                    )}

                    <p className="font-bold text-white">
                      <strong>Precio:</strong>
                      <br />
                      ${Number(finalPrice).toFixed(2)}
                    </p>

                    <p
                      className={`font-bold ${isPastEvent
                        ? "text-red-400"
                        : "text-green-400"
                        }`}
                    >
                      {isPastEvent
                        ? "Evento Finalizado"
                        : "Evento Activo"}
                    </p>

                    {selectedTicket.qrCode && (
                      <div className="flex justify-center">
                        <img
                          src={selectedTicket.qrCode}
                          alt="QR"
                          className="w-32 mt-2"
                        />
                      </div>
                    )}

                    <button
                      onClick={() =>
                        downloadTicketPDF(selectedTicket)
                      }
                      className="secondary text-white px-4 py-2 rounded mt-3"
                    >
                      Descargar Entrada
                    </button>
                  </>
                );
              })()}

            </div>
          </div>
        )}

        {/* PAGINATION CENTRADO */}
        <div className="flex justify-center items-center gap-3 mt-6">

          <button disabled={page === 1} onClick={() => setPage(1)}>
            ⏮
          </button>

          <button disabled={page === 1} onClick={() => setPage(page - 1)}>
            ◀
          </button>

          <span className="text-gray-300">
            Página {page} de {totalPages || 1}
          </span>

          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
            ▶
          </button>

          <button disabled={page === totalPages} onClick={() => setPage(totalPages)}>
            ⏭
          </button>


        </div>
          {/* BOTÓN VIDRIO */}

{/* BOTÓN VIDRIO */}

{user?.isAdmin && user?.email === "solticket.show@gmail.com" && (
  <div className="flex justify-center mt-4">
    <button
      onClick={() => setShowRegister(true)}
      className="px-5 py-4 rounded-xxl bg-white/5 border border-white/10 backdrop-blur-md text-white/40 hover:bg-white/10 hover:text-white/80 hover:border-white/20 transition-all duration-300"
    >
    </button>
  </div>
)}

{showRegister && (
  <Register onClose={() => setShowRegister(false)} />
)}

{showRegister && (
  <Register onClose={() => setShowRegister(false)} />
)}

      </div>
    </div>
  );
};

export default SalesSummaryPage;
